export class responseRemoveFileExpense {
    deleted:number;
    constructor (deleted) {
        this.deleted = deleted;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/http/res/response-remove-file-expense.ts